import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { LocalizedLink } from '@/components/LocalizedLink'

export function NotFound() {
  const { t, i18n } = useTranslation(['legal', 'common'])

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('legal:notFound.meta.title')}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="min-h-screen flex items-center justify-center bg-gray-50 pt-20">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-lg mx-auto"
          >
            <div className="text-7xl sm:text-9xl font-bold text-gray-200 mb-3 sm:mb-4">404</div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              {t('legal:notFound.title')}
            </h1>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8">
              {t('legal:notFound.description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild>
                <LocalizedLink to="home">
                  <Home className="mr-2 h-4 w-4" />
                  {t('common:buttons.backToHome')}
                </LocalizedLink>
              </Button>
              <Button asChild variant="secondary">
                <LocalizedLink to="contacts">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  {t('common:buttons.contactUs')}
                </LocalizedLink>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}
